
<ng-container *ngIf="{row: columnData | async,adata: additionData | async} as $">

    <div *ngIf="$.row && $.row.is_ewallet_deposit && $.row.is_ewallet_deposit == true; else prefix" class="flex align-items-center">
      <i class="fa fa-wallet mr-2"></i>  {{'INVOICE.COLUMNS.E_WALLET' | translate}}
    </div>
    <!-- <ng-template #prefix>
        <a class="text-primary" href="javascript:void(0)" (click)="OpenPdf($.adata.type, $.row,$.adata)" >{{$.row[$.adata.fetch_key]}}</a> 
    </ng-template> -->
    <ng-template #prefix>
      <div *ngIf="($.adata.type == getPdfType.Invoice || $.adata.type.toString() == getPdfType[getPdfType.Invoice]) && $.row.invoiceNumbers && $.row.invoiceNumbers.length > 0; else showprefix">
        <ng-container *ngFor="let invoice of $.row.invoiceNumbers">
          <a class="text-primary" href="javascript:void(0)" (click)="OpenPdf($.adata.type, $.row,$.adata,invoice)" >{{invoice}}</a> 
        </ng-container> 
      </div>
      <ng-template #showprefix>
        <a class="text-primary" href="javascript:void(0)" (click)="OpenPdf($.adata.type, $.row,$.adata,$.row[$.adata.fetch_key])" >{{$.row[$.adata.fetch_key]}}</a> 
        <span *ngIf="($.adata.type == getPdfType.Payment || $.adata.type.toString() == getPdfType[getPdfType.Payment])"  [pTooltip]="" tooltipStyleClass="text-xs" class="ml-2 w-1rem">
          <img *ngIf="$.row.settlement_id && $.row.settlement_id !== ''" width="20" src="assets/img/icons/double-check.png" alt="Icon" [pTooltip]="'Settlement'" >
          <img *ngIf="$.row.dispute_status && $.row.dispute_status !== 'None'" width="20" src="assets/img/icons/cart-error.png" alt="Icon" [pTooltip]="'Dispute'">
        </span>
      </ng-template>
    </ng-template>
  </ng-container>